import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import MlmuserEditFormImpl from './MlmuserEditFormImpl';
import MlmuserList from './MlmuserList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import MlmuserListView from './MlmuserListView'


export default function MlmuserDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.dmpslice.mlmuserDashboard);
  const [ mlmuserId, setMlmuserId] = React.useState('');
  const [reloadMlmuserList, setReloadMlmuserList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <MlmuserEditFormImpl 
            setReloadMlmuserList={setReloadMlmuserList}
            mlmuserId={mlmuserId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <MlmuserListView 
                      setMlmuserId = {setMlmuserId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
